// 46855: the two replacements for borderless buttons. CloseBtn = bordered icon-only close/remove/dismiss (tbl-ico-btn + line icon, bilingual aria-label);
// Tx = a translated literal for places that cannot call a hook (labels moved off English-only text).
import React from 'react';
import { useTranslation } from 'react-i18next';
import { IcoLn } from '../shell/ActionIcons';

export function Tx({ k }) { const { t } = useTranslation(); return t(k); }

export function CloseBtn({ kind = 'close', label, style, ...rest }) {
  const { t } = useTranslation();
  const text = label || t(`ghost.${kind}`);
  return <button type="button" className="tbl-ico-btn" aria-label={text} title={text} style={style} {...rest}><IcoLn name="close" /></button>;
}
